import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AppliedOffer, SelectedOffer } from '../models/offer.model';
import { OfferViewModel } from '../models/offer-view.model';
import { BrokerService } from './broker.service';
import { environment } from 'src/environments/environment';
import { DataLayersService } from './data-layers.service';
import { LoadService } from './load.service';
import { CookieService } from 'ngx-cookie-service';
import { SesionService } from './sesion.service';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class OfferService {

  public offerSelected: any;
  public offerApplied: AppliedOffer;
  public offerRequirement: boolean = true;
  public categories: Array<any> = [];
  public categoriesActive: Array<any> = [];
  public categorySel: any;
  public subCategories: Array<any> = [];
  public subCategorySel: any;
  public filters: Array<any> = [];
  public filtersSel: Array<any> = [];
  public offersList: OfferViewModel[] = [];
  public offersFil: OfferViewModel[] = [];
  public errorPreselecta = false;
  public filtersApply: any = [];
  public title_h1 = 'Descubre las oportunidades financieras de nuestros aliados: Créditos de vivienda, libre inversión, vehículos y créditos de microempresarios';
  public title_mobile_h1 = '¡Descubre oportunidades financieras a tu medida con Buscacrédito!';
  public hasSoftFilter: boolean = false;
  public errorApply = false;
  public loadingSoftFilter = true;
  public softFilterList: Array<any> = [];
  public load!: LoadService;

  constructor(private broker: BrokerService,
    private dataLayerService: DataLayersService,
    public cookieService: CookieService,
    public sesion: SesionService,
    private injector: Injector,
    private router: Router) {

    this.offerSelected = {
      company: {}, offer: {
        id: 0, labelType: '0', textLabel: '', positionOffer: 0, card: { productName: '' }, detail: {},
        terms: '', isApplied: false, decisorEngine: false, settings: {}
      },
      status: '', preselecta: { orderNumber: '', applyDate: '', urlRedirect: '' }
    };
    this.offerApplied = { company: {}, applyDetail: {}, email: '', orderNumber: '', terms: '', applyDate: '', encryptedInfo: '' };
    this.setCategories();
    this.setFilters();
  };

  /**
   * Funcion que generar una nueva de lista de la ofertas de los servicios pero en solo array se incluye toda la informacion relevante
   * en un objeto de oferta y se agrega a la nueva lista
   * @param offersList lista de ofertas de los servicios
   * @param free variable para saber si la lista es de freeOffers
   * @returns ofertas convertidas para el uso del front
   */
  convertOffer(offersList: any, free = false): OfferViewModel[] {
    let newOffersList: OfferViewModel[] = [];

    // ── Normaliza el wrapper del backend ──────────────────────────────────
    // El backend puede responder como:
    //   { code, message, data: [...] }  ← estructura real actual
    //   Array directo de compañías      ← estructura legacy
    let companies: any[] = [];
    if (Array.isArray(offersList)) {
      companies = offersList;
    } else if (Array.isArray(offersList?.data)) {
      companies = offersList.data;
    } else if (offersList?.company && Array.isArray(offersList?.offers)) {
      companies = [offersList];
    } else {
      // Intenta extraer de cualquier propiedad array conocida
      const fallback = offersList?.response ?? offersList?.result ?? offersList?.results ?? offersList?.payload;
      companies = Array.isArray(fallback) ? fallback : [];
    }

    // ── Helpers de normalización ──────────────────────────────────────────
    const toArr = (val: any): any[] => {
      if (Array.isArray(val)) return val;
      if (val == null) return [];
      if (typeof val === 'string') return val.length ? [val] : [];
      return Object.values(val);
    };

    const normalizeFilters = (raw: any): any[] => {
      const arr = toArr(raw);
      return arr.filter((f: any) => f != null).map((f: any) => ({
        ...f,
        id: Number(f?.id),
        values: f?.values
      }));
    };

    companies.forEach((offer: any) => {
      const companyOffers: any[] = Array.isArray(offer?.offers) ? offer.offers : [];
      companyOffers.forEach((companyOffer: any) => {

        // detail puede venir dentro de la oferta o estar ausente
        const rawDetail: any = companyOffer?.detail ?? {};

        // Construye el objeto detail normalizado
        const detail: any = {
          ...rawDetail,
          // subcategories: viene a nivel companyOffer (nueva estructura) o dentro de detail (legacy)
          subcategories: (() => {
            const sub = companyOffer?.subcategories
              ?? rawDetail?.subcategories
              ?? rawDetail?.['subcategories:$'];
            return toArr(sub).filter((s: any) => typeof s === 'string' && s.length > 0);
          })(),
          // filters: viene a nivel companyOffer (nueva estructura) o dentro de detail (legacy)
          filters: normalizeFilters(companyOffer?.filters ?? rawDetail?.filters),
          // Listas usadas por *ngFor en card — siempre arrays
          benefits: toArr(rawDetail?.benefits),
          requirements: toArr(rawDetail?.requirements),
          property: (() => {
            const p = rawDetail?.property;
            if (Array.isArray(p)) return p;
            if (p == null) return [];
            if (typeof p === 'object' && 'value' in p) return [p];
            return Object.values(p);
          })(),
          // Defaults para template
          companyLogoFlag: (() => {
            const v = rawDetail?.companyLogoFlag ?? companyOffer?.companyLogoFlag;
            if (typeof v === 'boolean') return v;
            if (typeof v === 'string') return v.toLowerCase() === 'true';
            return false;
          })(),
          additionalBenefits: (() => {
            const v = rawDetail?.additionalBenefits;
            if (typeof v === 'boolean') return v;
            if (typeof v === 'string') return v.toLowerCase() === 'true';
            return false;
          })(),
          // offerLogoURL puede venir dentro de detail o directamente en companyOffer
          offerLogoURL: rawDetail?.offerLogoURL ?? companyOffer?.offerLogoURL ?? '',
          categoryId: rawDetail?.categoryId ?? companyOffer?.categoryId ?? null,
        };

        const CONVERT_DEBUG = environment.gtmPruebas === true || environment.envName !== 'master';
        if (CONVERT_DEBUG) {
          console.log(`[convertOffer] "${companyOffer?.card?.productName}" → categoryId=${detail.categoryId} subcategories=${JSON.stringify(detail.subcategories)} filters=${detail.filters.length}`);
        }

        const offerAuxTmp: any = {
          labelType: companyOffer?.labelType == null || companyOffer?.labelType === '' ? '0' : companyOffer.labelType,
          textLabel: companyOffer?.textLabel ?? '',
          positionOffer: companyOffer?.positionOffer ?? 0,
          card: companyOffer?.card ?? {},
          company: offer?.company ?? {},
          detail,
          offerId: companyOffer?.id ?? 0,
          url: environment.urlLogin,
          terms: companyOffer?.terms ?? '',
          timeOffer: '',
          isApplied: companyOffer?.isApplied ?? false,
          free,
          decisorEngine: companyOffer?.decisorEngine ?? false,
          urlRedirect: companyOffer?.applyDetail?.urlRedirect ?? '',
          preselecta: {},
          idOffer: companyOffer?.idOffer ?? '',
          settings: companyOffer?.settings ?? {}
        };

        newOffersList.push(offerAuxTmp);
      });
    });
    return newOffersList;
  }

  /**
   * Funcion que carga el archivo de categorias y carga las categorias activas
   */
  setCategories() {
    if (this.categories.length == 0) {
      this.broker.getCategories().subscribe((response: any) => {
        this.categories = Array.isArray(response) ? response : response?.categories ?? [];
        this.categoriesActive = this.categories.filter((element: any) => element.state == 1);
      });
    }
  }

  /**
   * Funcion que carga el archivo de filters para saber las configuracion de los filtros
   */
  setFilters() {
    if (this.filters.length == 0) {
      this.broker.getFilters().subscribe((response: any) => {
        this.filters = Array.isArray(response) ? response : response?.filters ?? [];
        // this.categoriesActive = this.categories.filter((element: any) => element.state == 1);
      });
    }
  }

  /**
   * Funcion que filtrar las ofertar deacuerdo al id del filtro seleccionado, si no viene id se filtra solo por categoria y sub-categoria
   * si viene el id del filtro verifica si ya se han realizado filtros buscando en la variable filtersApply para filtrar de nuevo despues
   * realiza el proceso de filtrado del filtro seleccionado y ordena las ofertas
   * @param idFilter id del filtro
   * @param val valor a filtrar
   */
  setFilterOffer(idFilter: number = 0, val: any = null) {
    const FILTER_DEBUG = environment.gtmPruebas === true || environment.envName !== 'master';

    this.offersFil = this.offersList;

    // ── Filtro por categoría ───────────────────────────────────────────────
    if (this.categorySel != undefined) {
      const anyHasCatId = this.offersList.some((o: any) => o?.detail?.categoryId != null);
      if (anyHasCatId) {
        this.offersFil = this.offersList.filter(
          (ele: any) => String(ele?.detail?.categoryId) === String(this.categorySel.id)
        );
      }
      // Si ninguna oferta trae categoryId (nueva estructura) se muestra todo
    }

    // ── Filtro por subcategoría ────────────────────────────────────────────
    if (this.subCategorySel != undefined) {
      const anyHasSub = this.offersFil.some((o: any) => {
        const sub = o?.detail?.subcategories;
        return Array.isArray(sub) && sub.length > 0;
      });
      if (anyHasSub) {
        this.offersFil = this.offersFil.filter((ele: any) => {
          const sub: any[] = ele?.detail?.subcategories ?? [];
          return sub.includes(this.subCategorySel.acronyn);
        });
      }
    }

    if (FILTER_DEBUG) {
      console.log(`[setFilterOffer] START id=${idFilter} val=${JSON.stringify(val)}`, {
        offersListCount: this.offersList.length,
        afterCatSubCat: this.offersFil.length,
        categorySel: this.categorySel?.name ?? null,
        subCategorySel: this.subCategorySel?.name ?? null,
        filtersApply: [...this.filtersApply],
        filtersSel: this.filtersSel.map((f: any) => ({ id: f.id, type: f.type }))
      });
    }

    // ── Filtros avanzados (range / bool / check / text) ────────────────────
    if (idFilter != 0) {
      // Re-aplica filtros anteriores sobre el resultado actual
      const otherFilters = this.filtersApply.filter((ele: any) => ele.id != idFilter);
      otherFilters.forEach((element: any) => {
        const beforeCount = this.offersFil.length;
        switch (element.type) {
          case 'range': this.filterRange(element.id, element.val); break;
          case 'bool': this.filterBool(element.id, element.val); break;
          case 'check': this.filterCheck(element.id, element.val); break;
          case 'text': this.filterText(element.id, element.val); break;
        }
        if (FILTER_DEBUG) {
          console.log(`[setFilterOffer] re-apply id=${element.id} type=${element.type} val=${JSON.stringify(element.val)} : ${beforeCount} → ${this.offersFil.length}`);
        }
      });

      // Aplica el filtro nuevo
      const filterSearch = this.filters.find((ele: any) => ele.id == idFilter);
      if (FILTER_DEBUG) {
        console.log(`[setFilterOffer] applying NEW filter id=${idFilter} type=${filterSearch?.type ?? 'NOT FOUND IN filter.json'}`);
      }
      if (filterSearch?.type) {
        const beforeNew = this.offersFil.length;
        switch (filterSearch.type) {
          case 'range': this.filterRange(idFilter, val); break;
          case 'bool': this.filterBool(idFilter, val); break;
          case 'check': this.filterCheck(idFilter, val); break;
          case 'text': this.filterText(idFilter, val); break;
        }
        if (FILTER_DEBUG) {
          console.log(`[setFilterOffer] after NEW filter id=${idFilter}: ${beforeNew} → ${this.offersFil.length}`);
        }
      }
    }

    this.offersFil = this.sortOffer(this.offersFil);
    if (FILTER_DEBUG) {
      console.log(`[setFilterOffer] RESULT → ${this.offersFil.length} offers`);
    }
  }

  /**
   * Funcion que actualiza los filtros que se han realizado para se mantengan todos, si el filtro ya existe lo actualiza
   * si no lo agrega
   * @param idFilter id del filtro
   * @param val valor a filtrar
   * @param type tipo del filtro
   */
  setActuallyFilter(idFilter: number, val: any = null, type: string) {
    if (this.filtersApply.length > 0) {
      let actuallyFilter = this.filtersApply.find((ele: any) => ele.id == idFilter);
      if (actuallyFilter == undefined) {
        let filterApply = {
          id: idFilter,
          type: type,
          val: val
        }
        this.filtersApply.push(filterApply);
      } else {
        actuallyFilter.val = val;
      }
    } else {
      let filterApply = {
        id: idFilter,
        type: type,
        val: val
      }
      this.filtersApply.push(filterApply);
    }
  }

  /**
   * Funcion que valida que el filtro seleecioanado conincida con las ofertas a filtrar, y si aplica filtra
   * el valor de acuerdo a el tipo de filtro range que usa los valores min y max
   * @param idFilter id del filtro
   * @param val valor a filtrar
   */
  filterRange(idFilter: number, val: any = null) {
    const numVal = Number(val);
    const result: any[] = [];
    this.offersFil.forEach((element: any) => {
      const filters: any[] = element?.detail?.filters ?? [];
      const match = filters.find((f: any) => Number(f?.id) === idFilter);
      // Si la oferta no declara este filtro, pasa sin restricción
      if (!match) { result.push(element); return; }
      const v = match.values;
      if (v != null && typeof v === 'object' && v.min != null && v.max != null) {
        if (Number(v.min) <= numVal && numVal <= Number(v.max)) result.push(element);
      } else if (v != null && typeof v !== 'object') {
        // Valor escalar: se incluye si el valor solicitado no supera el máximo declarado
        if (numVal <= Number(v)) result.push(element);
      }
    });
    this.offersFil = result;
    this.setActuallyFilter(idFilter, val, 'range');
  }

  /**
   * Funcion que valida que el filtro seleecioanado conincida con las ofertas a filtrar, y si aplica filtra
   * el valor de acuerdo a el tipo de filtro bool que usa el valor values
   * @param idFilter id del filtro
   * @param val valor a filtrar
   */
  filterBool(idFilter: number, val: any = null) {
    if (val !== 'todas') {
      const valStr = String(val);
      const result: any[] = [];
      this.offersFil.forEach((element: any) => {
        const filters: any[] = element?.detail?.filters ?? [];
        const match = filters.find((f: any) => Number(f?.id) === idFilter);
        // Si la oferta no declara este filtro booleano, pasa sin restricción
        if (!match) { result.push(element); return; }
        if (String(match.values) === valStr) result.push(element);
      });
      this.offersFil = result;
    }
    this.setActuallyFilter(idFilter, val, 'bool');
  }

  /**
   * Funcion que valida que el filtro seleecioanado conincida con las ofertas a filtrar, y si aplica filtra
   * el valor de acuerdo a el tipo de filtro bool que usa el valor values
   * @param idFilter id del filtro
   * @param val valor a filtrar
   */
  filterCheck(idFilter: number, val: any = null) {
    if (val !== 'todas') {
      const valStr = String(val);
      const result: any[] = [];
      this.offersFil.forEach((element: any) => {
        const filters: any[] = element?.detail?.filters ?? [];
        const match = filters.find((f: any) => Number(f?.id) === idFilter);
        if (!match) return;
        const v = match.values;
        // Soporta values como array (multi-valor) o valor simple
        const matched = Array.isArray(v)
          ? v.map(String).includes(valStr)
          : String(v) === valStr;
        if (matched) result.push(element);
      });
      this.offersFil = result;
    }
    this.setActuallyFilter(idFilter, val, 'check');
  }

  filterText(idFilter: number, val: any = null) {
    if (val !== 'todas') {
      const numVal = Number(val);
      const result: any[] = [];
      this.offersFil.forEach((element: any) => {
        const filters: any[] = element?.detail?.filters ?? [];
        const match = filters.find((f: any) => Number(f?.id) === idFilter);
        // Si la oferta no declara este filtro, pasa sin restricción
        if (!match) { result.push(element); return; }
        const v = match.values;
        if (v != null && typeof v === 'object' && v.min != null && v.max != null) {
          // Rango declarado: el monto solicitado debe caer dentro del rango de la oferta
          if (Number(v.min) <= numVal && numVal <= Number(v.max)) result.push(element);
        } else if (v != null && typeof v !== 'object') {
          // Valor escalar: se incluye si el monto solicitado no supera el máximo declarado
          if (numVal <= Number(v)) result.push(element);
        }
      });
      this.offersFil = result;
    }
    this.setActuallyFilter(idFilter, val, 'text');
  }

  /**
   * Funcion que orderna la ofertas de menor a mayor teniendo en cuenta el campo positionOffer si este viene en 0 las ordena de manera aleatoria
   * @param listOffers lista de ofertas
   * @returns lista de ofertas ordenada
   */
  sortOffer(listOffers: OfferViewModel[]): OfferViewModel[] {
    const offerRandom = listOffers.filter(ele => ele.positionOffer == 0);
    const offerPosition = listOffers.filter(ele => ele.positionOffer > 0);
    offerRandom.sort(() => Math.random() - 0.5);
    offerPosition.sort((a, b) => Number(a.positionOffer) - Number(b.positionOffer));
    return [...offerPosition, ...offerRandom];
  }

  /**
   * Funcion para limpiar del local storage la informacion de una oferta seleccionada
   */
  clearOfferlocalStorage() {
    localStorage.removeItem("offerId");
    localStorage.removeItem("companyId");
    localStorage.removeItem("modal");
    localStorage.removeItem("companyName");
    localStorage.removeItem("productName");
    localStorage.removeItem("landingByOffer");
  }

  validateSoftFilters() {
    this.load = this.injector.get(LoadService);
    this.loadingSoftFilter = true;
    this.hasSoftFilter = false;
    let request = {
      idSession: this.cookieService.get('IDSESSIONMDC'),
      companyId: this.offerSelected.company.id,
      offerId: this.offerSelected.offerId
    }
    this.broker.softFilters(request).subscribe({
      next: (res: any) => {
        this.softFilterList = res;
        let hasRejectedFilters = false;

        this.softFilterList.forEach(item => {

          if (item.evaluated && !item.passed) {
            this.hasSoftFilter = true;
            hasRejectedFilters = true;
          }

          else if (!item.evaluated && !item.passed) {
            this.hasSoftFilter = true;
          }

        })

        this.loadingSoftFilter = false;

        let softFiltersRejectionReasons = this.getRejectedFilters();
        // Si hay filtros rechazados evaluados, registrar el intento y mostrar modal de rechazo
        if (hasRejectedFilters) {
          this.load.typeNoOffers = 1;

          // Registrar el intento de aplicación con filter=true (rechazo)
          const requestApply = {
            idSession: this.cookieService.get('IDSESSIONMDC'),
            companyId: this.offerSelected.company.id,
            offerId: this.offerSelected.offerId,
            filter: true,
            softFiltersRejectionReasons: softFiltersRejectionReasons
          };
          this.broker.aplicarOferta(requestApply).subscribe();

          // Cerrar el modal de confirmación y esperar a que termine la animación
          // antes de abrir el modal de rechazo para evitar conflictos de Bootstrap
          const $confirmModal = $('#confirmationModalV2');
          const openNoOfertasModal = () => {
            this.load.open('#noOfertasModal', '', '', false, undefined);
          };

          if ($confirmModal.hasClass('show') || $confirmModal.hasClass('in')) {
            $confirmModal.one('hidden.bs.modal', () => {
              openNoOfertasModal();
            });
            $confirmModal.modal('hide');
          } else {
            openNoOfertasModal();
          }

          return;
        }

        this.sesion.confirmTelephoneConecta = this.offerSelected.settings.aws ? true : false;
        if (this.sesion.ecsInfo && this.sesion.ecsInfo.params && this.sesion.ecsInfo.params[3] && this.sesion.ecsInfo.params[3].value && this.hasSoftFilter) {
          this.sesion.stepConfirmTelephone = 3;
          this.openConfirmTelephone();
        } else if (this.sesion.ecsInfo && this.sesion.ecsInfo.params && this.sesion.ecsInfo.params[3] && this.sesion.ecsInfo.params[3].value) {
          if (this.offerSelected.settings.aws) {
            this.load.openBcConecta();
          } else {
            this.sesion.stepConfirmTelephone = 4;
            this.openConfirmTelephone();
          }
        } else {
          this.sesion.stepConfirmTelephone = 1;
          this.openConfirmTelephone();
        }
        // El modal de confirmacion no siempre refresca solo via zone.js al reabrirse (ver LoadService.confirmModalChanged).
        this.load.confirmModalChanged.next();
      },
      error: (err: any) => {
        console.error(err)
        this.loadingSoftFilter = false;
        this.load.confirmModalChanged.next();
        this.clearOfferlocalStorage();
        this.router.navigate(['/error']);
      }
    });
  }

  openConfirmTelephone() {
    let idModal = '#confirmationModalV2';
    let buttonId = this.isButtonIdValid(this.offerSelected.card.buttonId);
    this.load.open(idModal, buttonId, '', false, undefined);
  }


  isButtonIdValid(buttonId: string) {
    return (typeof buttonId === 'string' ? buttonId : '0');
  }

  getRejectedFilters() {
    return this.softFilterList.filter((item: any) => !item.passed)
      .map((resFilter: any) => {
        return {
          filterName: resFilter.filterName,
          customerValue: resFilter.customerValue,
          value: resFilter.params
        };
      });
  }

}